export default __webpack_public_path__ + "static/media/header.f294db5e.png";